
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import Brieffelder from '@/components/Briefarten/Brieffelder.vue';
    import Briefart from '@/types/Briefart';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import { Resettable, VForm } from '@/types/Components';
    import { BriefartenFilter, DeleteBriefartenPayload, UpdateBriefartenPayload } from '@/store/briefarten';

    @Component({
        components: {
            Brieffelder,
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('briefarten', ['loaders', 'platzhalter']),
        },
        methods: {
            ...mapActions('briefarten', ['loadBriefarten', 'updateBriefart', 'deleteBriefart']),
        },
    })
    export default class BriefartenDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() briefart!: Briefart;
        @Prop() filter!: BriefartenFilter;

        public $refs!: {
            form: VForm;
            brieffelder: Resettable;
        };

        public updateBriefart!: (payload: UpdateBriefartenPayload) => void;
        public deleteBriefart!: (payload: DeleteBriefartenPayload) => void;

        public get isEdit(): boolean {
            return this.briefart.briefart_id !== null;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }

                if (this.$refs.brieffelder) {
                    this.$refs.brieffelder.reset();
                }
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateBriefart({ briefart: this.briefart, filter: this.filter });
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Briefart endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteBriefart({ briefart: this.briefart, filter: this.filter });
                    }
                });
        }
    }
